import React from 'react';

import { IMPORTANT_SAFETY_INFO_LINK_LABEL_DEFAULT } from 'consts/copy';

import {
  ImportantSafetyInfo,
  ImportantSafetyInfoLinkTag,
} from './ImportantSafetyInfoLink.style';

export interface ImportantSafetyInfoLinkProps {
  label?: string;
  url: string;
}

export const ImportantSafetyInfoLink = ({
  label,
  url,
}: ImportantSafetyInfoLinkProps) => {
  return (
    <ImportantSafetyInfo>
      <small>
        <ImportantSafetyInfoLinkTag href={url}>
          {label || IMPORTANT_SAFETY_INFO_LINK_LABEL_DEFAULT}
        </ImportantSafetyInfoLinkTag>
      </small>
    </ImportantSafetyInfo>
  );
};
